
import analytics from '@/helpers/analytics'

export default {
  data () {
    return {
      langCurrencyModalOpen: false,
      langCurrencyDefaultTab: 'language'
    }
  },
  computed: {
    siteType () {
      return this.$store.state.siteType
    },
    phone () {
      return this.$store.getters.phone
    },
    logo () {
      return `/images/logos/${this.$store.state.site}.png`
    }
  },
  methods: {
    openLangCurrencyModal (tab = 'language') {
      this.langCurrencyDefaultTab = tab
      this.langCurrencyModalOpen = true
    },
    closeLangCurrencyModal () {
      this.langCurrencyModalOpen = false
    },
    onConfirm ({ language, currency }) {
      this.$store.commit('setDestinationCurrency', currency)
      this.closeLangCurrencyModal()
      this.changeLanguage(language)
    },
    changeLanguage (languageCode) {
      this.$cookies.set('lang', languageCode)
      this.$i18n.locale = languageCode
      this.$store.commit('setLanguage', languageCode)
      this.$store.commit('setRtl', ['he'].includes(languageCode))
      const fullPath = this.$route.fullPath
      const redirect = this.$store.state.translationRedirects[languageCode]
      if (redirect) return this.$router.push(redirect)
      if (fullPath.startsWith('/blog')) return this.$router.push(`/blog/${languageCode}`)
      if (fullPath.startsWith('/contact') || fullPath.startsWith('/about')) return window.location.reload()
    },
    clickPhone (event) {
      analytics.track('phone-click', this)
      window.top.location = `tel:${this.phone}`
    }
  }
}
